import usePrivateAxios from '@/common/api/usePrivateAxios'
import { UpdateContractBillDetailsSchema } from '@/features/establishments/schemas/contract/updateBillDetails.schema'
import { useMutation } from '@tanstack/react-query'

interface UseUpdateContractBillDetails {
  contractId?: string
  onSuccess?: (response: any) => void
  onError?: (error: any) => void
}

export const useUpdateContractBillDetails = ({ contractId, onSuccess, onError }: UseUpdateContractBillDetails) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateContractBillDetails'],
    mutationFn: async (data: UpdateContractBillDetailsSchema) => {
      const contract = {
        cycle: data.contract?.cycle?.value || undefined,
        cycle_start_day: data.contract?.cycle_start_day?.value || undefined,
        closing_to_due_in_days: data.contract?.closing_to_due_in_days?.value || undefined,
      }

      await privateAxios.put(`/establishment/contracts/${contractId}/update_contract_bill_information`, {
        contract,
      })
    },
    onSuccess,
    onError,
  })
}
